import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, Text } from 'shell/components';

const PasswordResetSuccess = ({ device, onLogin }) => {
    const { t } = useTranslation('auth');

    return (
        <Card device={device}>
            <Stack alignItems={'center'} spacing={1}>
                <Text component={'h1'} variant={'h6'} weight={'medium'}>
                    {t('forgot-password.success-title', 'Password reset successful')}
                </Text>
                <Text variant={'p1'} align={'center'}>
                    {t(
                        'forgot-password.success-description',
                        'Your password has been successfully reset! Please log in with your new password.'
                    )}
                </Text>
            </Stack>
            <Button sx={{ mt: 6, width: '100%' }} onClick={onLogin}>
                {t('forgot-password.log-in', 'Log In')}
            </Button>
        </Card>
    );
};

const Card = styled(Box)(({ theme, device }) => ({
    marginTop: theme.spacing(10),
    padding: device === 'mobile' ? 0 : theme.spacing(7),
    width: device === 'mobile' ? '100%' : 448,
    background: device === 'mobile' ? 'transparent' : theme.palette.ensightful.shades[0],
    boxShadow: device === 'mobile' ? 'none' : theme.palette.ensightful.shadows[1],
    borderRadius: '20px',
}));

export default PasswordResetSuccess;
